import React, { Component } from "react";

import axios from "../../sagas/axios";
import Contents from '../../../contents/index';
import Loader from "../../components/loader";
import ModalAlert from "../../components/modal/modal_alert";
import ModalLoader from "../../../modal/modal_loader";

export default class Root extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: this.props.title || "",
      mainImageUrl: this.props.mainImageUrl || "",
      loading: false,
      isNextButtonDisplayed: true,
    };
    this.successRef = React.createRef();
    this.errorRef = React.createRef();
    this.loaderRef = React.createRef();
    this.onSubmit = this.onSubmit.bind(this);
    this.toCoursesPage = this.toCoursesPage.bind(this);
    this.onClickImage = this.onClickImage.bind(this);
    this.onChangeMainImage = this.onChangeMainImage.bind(this);
    this.onChangeField = this.onChangeField.bind(this);
  }

  onSubmit(e) {
    e.preventDefault();
    this.loaderRef.current.openModal();
    const body = JSON.stringify({
      course_id: this.props.courseId,
      title: this.state.title,
    });
    axios
      .post("/api/courses/update", body)
      .then((response) => {
        this.loaderRef.current.closeModal();
        if (response.status === 200) {
          this.successRef.current.openModal();
        } else {
          this.errorRef.current.openModal();
        }
      })
      .catch(() => {
        this.loaderRef.current.closeModal();
        this.errorRef.current.openModal();
      });
  }

  toCoursesPage() {
    window.location.href = "/admin/courses";
  }

  onClickImage() {
    $("#mainImage").click();
  }

  onChangeMainImage(e) {
    this.setState({ loading: true });
    const file = e.target.files[0];
    let formData = new FormData();
    formData.append("course_id", this.props.courseId);
    formData.append("file", file);
    axios
      .post("/api/courses/upload_main_image", formData)
      .then((response) => {
        this.setState({
          mainImageUrl: response.data.main_image_url,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({
          loading: false,
        });
      });
  }
  onChangeField(e) {
    this.setState({ title: e.target.value });
  }

  render() {
    const mainImageUrl = this.state.mainImageUrl;
    let imageUploadView;
    if (mainImageUrl !== "") {
      imageUploadView = (
        <img
          src={mainImageUrl}
          alt=""
          className="card-img-top card-img-top--list_bgwhite mb-0 w-100"
        />
      );
    } else {
      imageUploadView = (
        <div>
          <img
            src="/assets2019/img/icon_camera.svg"
            alt=""
            className="card-img-top card-img-top--list_bgwhite mb-0 w-100"
          />
          <span className="d-block text-center text-black-20 text-fz-small">
            メイン写真
          </span>
        </div>
      );
    }

    return (
      <div>
        <main
          style={{
            paddingBottom: this.props.isApp == false ? "165px" : "66px",
          }}
          className="bg-gray h-100 pt-3 min-vh-100"
        >
          <div className="container col-md-8 col-lg-6">
            {this.state.loading ? (
              <Loader isActive={this.state.loading} />
            ) : (
              <a
                className="card card--makecircle m-auto border-0 d-flex justify-content-center align-items-center hov--default p-3_5"
                onClick={this.onClickImage}
              >
                {imageUploadView}
                <input
                  type="file"
                  accept="image/png, image/jpeg, image/gif"
                  onChange={this.onChangeMainImage}
                  name="mainImage"
                  id="mainImage"
                  style={{ display: "none" }}
                />
              </a>
            )}
            <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
              イベント名
            </p>
          </div>
          <div className="shadow-sm mb-0 bg-white">
            <div className=" container col-md-8 col-lg-6 p-3_5">
              <textarea
                id="title"
                className="p-0 w-100 textarea--eventreport"
                defaultValue={this.props.title}
                onChange={this.onChangeField}
                rows="3"
              />
            </div>
          </div>
          <Contents
            foreignKeyId={this.props.courseId}
            isApp={this.props.isApp}
            model={"Course"}
            isCoursesDisplayed={true}
            displayNextButtonFunc={() =>
              this.setState({ isNextButtonDisplayed: true })
            }
            hideNextButtonFunc={() =>
              this.setState({ isNextButtonDisplayed: false })
            }
          />
        </main>
        {this.state.isNextButtonDisplayed && (
          <div className="fixed-bottom" style={{ paddingBottom: "8px" }}>
            <div className="container col-md-8 col-lg-6 d-flex justify-content-around">
              <div
                className="container d-flex justify-content-around"
                style={{ marginBottom: this.props.isApp ? "24px" : "" }}
              >
                <button
                  type="button"
                  className={`col-6 a-button a-button__top a-button--orange mr-2 w-100 ${
                    this.props.isApp == false ? "mb-2" : ""
                  }`}
                  onClick={this.onSubmit}
                >
                  作成/更新する
                </button>
              </div>
            </div>
          </div>
        )}
        <ModalAlert
          ref={this.successRef}
          title="コース作成完了"
          content="コース作成/更新に成功しました。"
          approveFunc={this.toCoursesPage}
        />
        <ModalAlert
          ref={this.errorRef}
          title="コース作成失敗"
          content="コース作成に失敗しました。時間をおいてもう一度お試しください。"
        />
        <ModalLoader ref={this.loaderRef} />
      </div>
    );
  }
}
